import { render, staticRenderFns } from "./customerEdit_ec.vue?vue&type=template&id=aa0d84c6&scoped=true&"
import script from "./customerEdit_ec.vue?vue&type=script&lang=js&"
export * from "./customerEdit_ec.vue?vue&type=script&lang=js&"
import style0 from "./customerEdit_ec.vue?vue&type=style&index=0&id=aa0d84c6&lang=less&scoped=true&"
import style1 from "./customerEdit_ec.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0d84c6",
  null
  
)

component.options.__file = "customerEdit_ec.vue"
export default component.exports